import { render, staticRenderFns } from "./Sparts.vue?vue&type=template&id=1eeab068&"
import script from "./Sparts.vue?vue&type=script&lang=ts&"
export * from "./Sparts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports